import { CustomLogicEvent } from '@msdk/common'
import { EntityOperation, ServerOperationResult } from '@msdk/definitions'

import { CollectionEntry } from '../state'

export type ValidatedForm = Pick<CollectionEntry, 'entity' | 'additionalEntities' | 'rootNode'>
type SaveResult = EntityOperation & { event?: CustomLogicEvent }

const invalidResult: SaveResult = {
  result: ServerOperationResult.Failure,
  entities: [],
  metadataList: [],
  messages: { entities: [] },
}

export async function saveValidated(
  validate: (() => Promise<ValidatedForm | null>) | null,
  save: (actionId?: string, validated?: ValidatedForm) => Promise<SaveResult>,
  actionId?: string,
): Promise<SaveResult> {
  if (!validate) {
    throw new Error('Form validation is not available')
  }

  const validated = await validate()
  if (!validated) {
    return invalidResult
  }

  return save(actionId, validated)
}
